module.exports = __webpack_public_path__ + "static/media/README.12685be0.md";